// extracted by mini-css-extract-plugin
export default {"Checkbox":"dd33119a783d"};